import { FC, memo, useContext, useState } from 'react';
import styles from './index.module.scss';
import IconPvPng from '../../../../imgs/icon-pv@2x.png';
import { formatPowerKWhAndUnit, formatThousandAndUnit, keepOneOrLine, keepOnePercentOrLine } from '@/utils/utils';
import { DoubleRightOutlined } from '@ant-design/icons';
import icon_pv from '../../../../imgs/icon-pv.png';
import { Tooltip } from '@maxtropy/components';
import { ShareDataUnityPowerMapContext } from '../..';
import GreenRateModal from '../GreenRateModal';
import classNames from 'classnames';

interface ICenterTopBox {
  className?: string;
  isNoMapLayout?: boolean;
}

const CenterTopBox: FC<ICenterTopBox> = ({ className, isNoMapLayout }) => {
  const [open, setOpen] = useState<boolean>(false);
  const { monthData, scaleData, yearData } = useContext(ShareDataUnityPowerMapContext);

  return (
    <div className={classNames(styles.topRow, isNoMapLayout && styles.noMapTopRow, className)}>
      <div className={styles.leftCard}>
        <div className={styles.cardHeader}>本月电力数据</div>
        <div className={styles.cardContent}>
          <div className={styles.columnItem}>
            <div className={styles.itemTitle}>本月用电(kWh)</div>
            <div className={styles.itemValue}>
              {formatPowerKWhAndUnit(monthData?.electricity).value}
              <span className={styles.unit}>{formatPowerKWhAndUnit(monthData?.electricity).unit}</span>
            </div>
          </div>
          <div className={styles.splitLine}></div>
          <div className={styles.columnItem}>
            <div className={styles.itemTitle}>光伏本月发电(kWh)</div>
            <div className={styles.itemValue}>
              {formatThousandAndUnit(monthData?.pvPower)?.value}
              <span className={styles.unit}>{formatThousandAndUnit(monthData?.pvPower)?.unit}</span>
            </div>
          </div>
          <div className={styles.columnItem}>
            <div className={styles.itemTitle}>绿电占比</div>
            <div className={styles.itemValue}>
              {keepOnePercentOrLine(monthData?.greenRate)}
              <span className={styles.unit}>%</span>
              <DoubleRightOutlined className={styles.detailIcon} onClick={() => setOpen(true)} />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.rightCard}>
        <div className={styles.cardHeader}>
          <span>本年电力数据</span>
        </div>
        <div className={styles.cardContent}>
          <div className={styles.columnItem}>
            <div className={styles.itemTitle}>本年用电(kWh)</div>
            <div className={styles.itemValue}>
              {formatThousandAndUnit(yearData?.electricity)?.value}
              <span className={styles.unit}>{formatThousandAndUnit(yearData?.electricity)?.unit}</span>
            </div>
          </div>
          <div className={styles.splitLine}></div>
          <div className={styles.columnItem}>
            <div className={styles.itemTitle}>
              光伏发电(kWh)
              <Tooltip
                trigger={'hover'}
                title={
                  <div className={styles.rowItem}>
                    <img className={styles.itemIcon} src={IconPvPng} alt="" />
                    <div className={styles.itemTitle}>光伏装机</div>
                    <div className={styles.itemValue}>{keepOneOrLine(scaleData?.installedCapacity)}MW</div>
                  </div>
                }
              >
                <img src={icon_pv} alt=""></img>
              </Tooltip>
            </div>
            <div className={styles.itemValue}>
              {formatThousandAndUnit(yearData?.pvPower)?.value}
              <span className={styles.unit}>{formatThousandAndUnit(yearData?.pvPower)?.unit}</span>
            </div>
          </div>
          <div className={styles.columnItem}>
            <div className={styles.itemTitle}>绿电占比</div>
            <div className={styles.itemValue}>
              {keepOnePercentOrLine(yearData?.greenRate)}
              <span className={styles.unit}>%</span>
              <DoubleRightOutlined className={styles.detailIcon} onClick={() => setOpen(true)} />
            </div>
          </div>
        </div>
      </div>

      {open && <GreenRateModal open={open} setOpen={setOpen} />}
    </div>
  );
};

export default memo(CenterTopBox);
